import { useCallback } from 'react';
import { useEventLogger, useNavigationHelper } from 'FrontRoyalAngular';

/*
    Opens an assigned reading link in a new tab, logging it first.

    Mirrors openExternalLink in stream_dashboard_external_links_dir.js, including the event name and its
    payload of a single `link` key.
*/
export function useOpenExternalLink() {
    const EventLogger = useEventLogger();
    const { loadUrl } = useNavigationHelper();

    return useCallback(
        (url: string) => {
            EventLogger.log('stream_dashboard_external_links:clicked_external_link', { link: url });
            loadUrl(url, '_blank');
        },
        [EventLogger, loadUrl],
    );
}
